import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { EMPTY } from 'rxjs';
import { Tile } from '../../widgets/tile/tile.component';
import { ServiceItem } from '../../../../services/framework/serviceitem';
import { BaseService } from '../../../../services/framework/base.service';

@Injectable({
  providedIn: 'root'
})
export class AssessmentsService extends BaseService<AssessmentItem>{

  piDomain: string = "";
  public _surveyId: number = 0;
  constructor(public http: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any) {
    super(http, auth);

    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
    this.getEndpoint = 'assessment/';

  }

  public GetTemplateQuestions(assessmentId: number): Observable<ISection[]> {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "templateQuestions?assessmentId=" + assessmentId;
    if (token != undefined) {
      return this.http.get<ISection[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }
  GetSections(assessmentId: number): Observable<ISection[]> {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "sections?assessmentId=" + assessmentId;
    if (token != undefined) {
      return this.http.get<ISection[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }
  deleteQuestion(deleteQuestionRequest: any): Observable<any> {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "deletequestion/" + this._surveyId;
    const _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    })
    //return this.http.delete(`${this.url}/${JSON.stringify(deleteQuestionRequest) }`, this.getHttpOptions(token));
    return this.http.request('DELETE', url, {headers: _headers, body: deleteQuestionRequest })
  }

  public addAdhocQuestions(assessmentId: number, _questionRequest: any): Observable<any> {
  
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "addAdhocQuestions";
   if (token != undefined) {
     return this.http.post(url + '/' + assessmentId, JSON.stringify(_questionRequest), this.getHttpOptions(token))
    }
    else {
      return EMPTY
    }
   
  }


}

export interface ISection  {
  questionId: number;
  questionText: string;
  questionType: string;
  sectionId: number;
  sectionName: string;
  isCustomQuestion: boolean;
  options: string[];
}
export interface AssessmentItem extends ServiceItem {
  text: string;
  imageUrl: string;
  actionUrl?: string;
  routerLink?: string;
  loginRequired?: any;
  sortOrder?: number;
  isActive?: boolean;
  tile: Tile;
  target?: string;
  surveyId?:string
}



